<!--
    Trace display for main report
    (There are other trace dsplays for the individual sections)
-->

<template>
  <v-layout v-if="shouldTrace">
    <v-container class="pa-0">
      <v-flex xs12 class="grey-background blue-text">
        <div class="encode title font-weight-black pa-3">Trace</div>
      </v-flex>
      <v-flex xs12 class="white-background blue-text trace-table">
        <table>
          <thead>
            <tr>
              <th align="left">Group</th>
              <th align="left">Name</th>
              <th align="right">Unweighted</th>
              <th align="right">Weight</th>
              <th align="right">Weighted</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="group in sections.map(s => htmlGroups.find(g => g.groupId==s.groupId))"
              :key="group.groupId"
            >
              <td>{{ group.groupId }}</td>
              <td>{{ group.name }}</td>
              <td align="right">{{ traceFmt(group.unweightedScore)}}</td>
              <td align="right">{{ traceFmt(group.weighting) }}</td>
              <td align="right">{{ traceFmt(group.weightedScore) }}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td></td>
              <td></td>
              <td></td>
              <td align="right">{{ traceFmt(this.totalScore) }}</td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
import { formatNumber } from "../utils/std.js";

export default {
  name: "ReportStartTrace",
  props: {
    htmlGroups: Array,
    sections: Array,
    totalScore: Number
  },
  methods: {
    traceFmt: function(val) {
      return formatNumber(val, 2);
    }
  },
  computed: {
    shouldTrace() {
      return !!this.$route.query.trace;
    }
  }
};
</script>
